import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Overlay } from 'barnyard/components';

const classNamePrefix = 'Signup--FormPage';

export const isProfileReady = profile => (
  profile.isFetched || profile.isError || Boolean(profile.id)
);

class MerchantSignupConfirm extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'closeSignupConfirm');

    this.state = {
      show: true,
    };
  }

  closeSignupConfirm() {
    this.setState({ show: false });
  }

  render() {
    const { profile } = this.props;
    const { show } = this.state;

    if (!show || !isProfileReady(profile)) {
      return null;
    }

    return (
      <Overlay
        show={show}
        location='center'
        closeable={true}
        isGlobalNode={true}
        boxClassName={`${classNamePrefix}__signupConfirmBox`}
        onClose={this.closeSignupConfirm}
      >
        <div className={`${classNamePrefix}__signupConfirm`}>
          <h1>Wait!</h1>
          <p>
            If you are a veterinary hospital, <a href='/accounts/signup/user'>click here to sign up</a> for Vetcove
            for your inventory purchasing or <a href='/auth/signin/'>click here to log in</a> if you already have
            a Vetcove account.
          </p>
          <p className={`${classNamePrefix}__signupConfirm__note`}>
            Click below to proceed if you are a manufacturer or vendor looking to sell your products on Vetcove.
          </p>
          <div className={`${classNamePrefix}__signupConfirm__actions`}>
            <Button color='primary' full={true} onClick={this.closeSignupConfirm}>
              Continue to Vendor Sign Up
            </Button>
          </div>
        </div>
      </Overlay>
    );
  }
}

MerchantSignupConfirm.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default MerchantSignupConfirm;
